<template>
    <v-content>
        <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>

     <v-snackbar v-model="snackbar.snackbar" color="success" :timeout="snackbar.servicesData.timeout" top>
            {{snackbar.servicesData.message}}
            <v-btn dark text @click="snackbar.snackbar = false">Close</v-btn>
        </v-snackbar>

       <!-- <h1 class="font-weight-light">{{role}} Information</h1>-->
        <div class="row">
            <div class="col-md-8">
                <v-card class="relative" flat>
                    <!-- <v-card-title class="absolute">
                                  <span class="title font-weight-light">Edit Informations</span>
                    </v-card-title>-->
                    <form class="px-2">
                        <v-row>
                            <!-- <v-input disabled>{{companyData.branchType}}</v-input> -->
                           <!-- <v-input disabled>{{branchTypeC}}</v-input>-->
                            <v-text-field
                                    v-model="companyData.name"
                                    :error-messages="companyNameErrors"
                                     :label="$t('name')"
                                    required dense outlined
                                    @input="$v.companyData.name.$touch()"
                                    @blur="$v.companyData.name.$touch()"
                                    :disabled="true" 
                                    class="col-12"
                            ></v-text-field>
                           
                                <v-menu
                                        v-model="snackbar.dateMenu"
                                        :close-on-content-click="true"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                         min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                v-model="companyData.establishedYearString"
                                                 :label="$t('establishmentYear')"
                                                clearable
                                                prepend-inner-icon="event"
                                                readonly
                                                v-on="on"
                                                :error-messages="companyEstablishedYearErrors"
                                                required dense outlined
                                                @input="$v.companyData.establishedYear.$touch()"
                                                @blur="$v.companyData.establishedYear.$touch()"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker class="col-6"
                                            v-model="companyData.establishedYearString"
                                    >
                                    </v-date-picker>
                                </v-menu>
                           
                            <v-text-field
                                    v-model="companyData.email"
                                   :label="$t('email')"
                                    required dense outlined
                                    class="col-12"
                            ></v-text-field>
                            <v-text-field
                                    v-model="companyData.phoneNumber"
                                    :error-messages="companyPhoneNumberErrors"
                                   :label="$t('phone')"
                                    required dense outlined
                                    @input="$v.companyData.phoneNumber.$touch()"
                                    @blur="$v.companyData.phoneNumber.$touch()"
                                    class="col-12"
                            ></v-text-field>
                            <v-text-field
                                    v-model="companyData.address"
                                    :error-messages="companyAddressErrors"
                                    :label="$t('address')"
                                    required dense outlined
                                    @input="$v.companyData.address.$touch()"
                                    @blur="$v.companyData.address.$touch()"
                                    class="col-12"
                            ></v-text-field>
                            <v-text-field
                                    v-model="companyData.website"
                                   :label="$t('website')"
                                    required dense outlined
                                    class="col-12"
                            ></v-text-field>
                            <!-- <v-file-input small-chips multiple label="Register Document"
                                                        show-size class="col-12"
                                          ></v-file-input>
                                          <v-file-input small-chips multiple label="Register Document"
                                                        show-size class="col-12"
                                          ></v-file-input>
                                          <v-file-input small-chips multiple label="Vat Document"
                                                        show-size class="col-12"
                            ></v-file-input>-->
                            <div class="col-12">
                                <v-btn dark text depressed class="mr-4 custom-save-button" @click="submit">Update</v-btn>
                            </div>
                        </v-row>
                    </form>
                </v-card>
            </div>
            <div class="col-md-4">
                <v-card class="mx-auto" outlined>
                    <v-list-item three-line>
                        <v-list-item-content>
                            <div class="overline mb-4">{{$t('profile')}}</div>
                            <v-list-item-title class="headline mb-1">{{companyData.branchName}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-img :src="companyData.logo" height="194"></v-img>
                    <v-file-input accept="image/png, image/jpeg, image/bmp"
                                  placeholder="Profile Image"
                                  prepend-icon="mdi-camera"
                                 :label="$t('profileImage')"
                                  class="pl-2"
                                  v-model="companyData.updateLogo"></v-file-input>
                    <v-textarea class="mx-2"
                                :label="$t('aboutus')"
                                rows="3" dense outlined
                                v-model="companyData.aboutUs"
                                prepend-icon="comment"
                                value="Kapan-3, Kathmandu, Nepal Kapan-3, Kathmandu, Nepal Kapan-3, Kathmandu, Nepal"
                                hint="Hint text"></v-textarea>
                </v-card>
                <v-expansion-panels v-if="role == 'SuperAdmin'">
                    <v-expansion-panel>
                        <v-expansion-panel-header color=" dark-blue">Documents</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-card class="py-5" text>
                                <v-row>

                                    <v-col cols="12">
                                        <v-file-input
                                                accept="image/png, image/jpeg, image/bmp"
                                                placeholder="Document 1"
                                                prepend-icon="mdi-camera"
                                                label="Document 1"
                                                class="pl-2"
                                                v-model="companyData.updateLogo"
                                        ></v-file-input>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-file-input
                                                accept="image/png, image/jpeg, image/bmp"
                                                placeholder="Document 2"
                                                prepend-icon="mdi-camera"
                                                label="Document 2"
                                                class="pl-2"
                                                v-model="companyData.updateLogo"
                                        ></v-file-input>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-file-input
                                                accept="image/png, image/jpeg, image/bmp"
                                                placeholder="Document 3"
                                                prepend-icon="mdi-camera"
                                                label="Document 3"
                                                class="pl-2"
                                                v-model="companyData.updateLogo"
                                        ></v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4">
                                        <v-dialog v-model="dialog" width="500">
                                            <template v-slot:activator="{ on }">
                                                <v-img
                                                        class="pb-2"
                                                        :src="companyData.registerDocument"
                                                        height="50"
                                                ></v-img>
                                            </template>

                                            <v-card>
                                                <v-card-title
                                                        class="headline grey lighten-2"
                                                        primary-title
                                                >Register Document</v-card-title>

                                                <v-card-text>
                                                    <v-img
                                                            class="pb-2"
                                                            :src="companyData.registerDocument"
                                                            aspect-ratio="1"
                                                    ></v-img>
                                                </v-card-text>

                                                <v-divider></v-divider>
                                            </v-card>
                                        </v-dialog>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-dialog v-model="dialog" width="500">
                                            <template v-slot:activator="{ on }">
                                                <v-img
                                                        class="pb-2"
                                                        :src="companyData.vatDocument"
                                                        height="50"
                                                ></v-img>
                                            </template>
                                            <v-card>
                                                <v-card-title class="headline grey lighten-2" primary-title>Vat Document</v-card-title>

                                                <v-card-text>
                                                    <v-img
                                                            class="pb-2"
                                                            :src="companyData.vatDocument"
                                                            aspect-ratio="1"
                                                    ></v-img>
                                                </v-card-text>

                                                <v-divider></v-divider>
                                            </v-card>
                                        </v-dialog>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-dialog v-model="dialog" width="500">
                                            <template v-slot:activator="{ on }">
                                                <v-img
                                                        class="pb-2"
                                                        :src="companyData.taxClearanceDocument"
                                                        height="50"
                                                ></v-img>
                                            </template>

                                            <v-card>
                                                <v-card-title
                                                        class="headline grey lighten-2"
                                                        primary-title
                                                >Tax Clearance Document</v-card-title>

                                                <v-card-text>
                                                    <v-img
                                                            class="pb-2"
                                                            :src="companyData.taxClearanceDocument"
                                                            aspect-ratio="1"
                                                    ></v-img>
                                                </v-card-text>

                                                <v-divider></v-divider>
                                            </v-card>
                                        </v-dialog>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </div>
    </v-content>
</template>

<script>
    import {required} from "vuelidate/lib/validators";
    import axios from "axios";
    import {mapGetters} from "vuex";

    export default {
        name: "CompanyProfile",
        props: ["success"],
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            companyAddressErrors() {
                const errors = [];
                if (!this.$v.companyData.address.$dirty) return errors;
                !this.$v.companyData.address.required &&
                errors.push("Company Address is required");
                return errors;
            },
            companyNameErrors() {
                const errors = [];
                if (!this.$v.companyData.name.$dirty) return errors;
                !this.$v.companyData.name.required &&
                errors.push("Company name is required.");
                return errors;
            },
            companyPhoneNumberErrors() {
                const errors = [];
                if (!this.$v.companyData.phoneNumber.$dirty) return errors;
                !this.$v.companyData.phoneNumber.required &&
                errors.push("Company Phone Number is required.");
                return errors;
            },
            companyEstablishedYearErrors() {
                const errors = [];
                if (!this.$v.companyData.establishedYear.$dirty) return errors;
                !this.$v.companyData.establishedYear.required &&
                errors.push("Company Establishment year is required.");
                return errors;
            },
            companyEmailErrors() {
                const errors = [];
                if (!this.$v.companyData.email.$dirty) return errors;
                !this.$v.companyData.email.required &&
                errors.push("Company Email is required.");
                return errors;
            },
            breadcrumbItems() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: `${this.userData.dashBoard}`,
                        exact: true
                    }
                ]
            },
        },
        data() {
            return {
                role: this.$store.getters.getUserRole,
                created: false,
                companyData: {},
                snackbar: {
                    dateMenu: false,
                    servicesData: {
                        timeout:5000,
                        data: {},
                        message: "",
                        color: ""
                    },
                   
                }
            };
        },
        mounted() {
            this.formData()
            this.loadBreadCrumbs()
        },
        validations: {
            companyData: {
                name: {required},
                email: {required},
                address: {required},
                website: {required},
                establishedYear: {required},
                phoneNumber: {required},
            }
        },
        methods: {
            loadBreadCrumbs(){
                this.snackbar.breadcrumbItems[0].to = this.usersData.dashBoard
            },
            async formData() {
                const companyData = await axios.get(
                    "Depo/GetDepoByID/" + parseInt(this.usersData.depoID)
                );
                this.companyData = companyData.data;
                console.log(this.companyData)
            },
            submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.submitStatus = "ERROR";
                } else {
                    var form = new FormData();

                    form.append(
                        "Documents.Logo",
                        this.companyData.updateLogo
                    );
                       form.append(
                           "DepoID",
                           this.usersData.depoID
                    );
                    form.append(
                        "Name",
                        this.companyData.name
                    );
                    form.append(
                        "Documents.EstablishedYear",
                        this.companyData.establishedYear
                    );
                    form.append(
                        "EstablishedYear",
                        this.companyData.establishedYearString

                    );
                    form.append(
                        "Email",
                        this.companyData.email
                    );
                    form.append(
                        "PhoneNumber",
                        this.companyData.phoneNumber
                    );
                    form.append(
                        "Address",
                        this.companyData.address
                    );

                    form.append(
                        "WebSite",
                        this.companyData.website
                    );
                    form.append(
                        "AboutUS",
                        this.companyData.aboutUs
                    );
                    axios.post("Depo/UpdateProfile", form).then(response => {
                        if (response.data.success) {
                            this.snackbar.snackbar = true
                            this.snackbar.servicesData.data = response.data
                            this.snackbar.servicesData.message = "Company added Successfully"
                            this.snackbar.servicesData.color = "success"
                            this.formData()
                        }
                    }).catch(response => {
                        this.snackbar.snackbar = true
                        this.snackbar.servicesData.data = response.data
                        this.snackbar.servicesData.message = "Error Adding Company, Please Contact Admin"
                        this.snackbar.servicesData.color = "error"
                        this.formResponse()
                    });
                }
            },
            clear() {
                this.$v.$reset();
                this.companyData = {};
            },
        }
    };
</script>

<style scoped>
</style>
